import type { RouteRecordRaw } from "vue-router";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { PATH_LOGS } from "~/modules/auditLog/constants";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_LOGS,
    component: () => import("~/modules/auditLog/views/LogsPage.vue"),
    meta: {
      breadcrumb: BREADCRUMBS.LOGS,
    },
  },
];

export default routes;
